import { checkConditions } from '../package/packageUtils';

export const getCoverageProperty = (coverageNode, code, prop) => {
  return coverageNode && coverageNode[code] && coverageNode[code][prop];
};

export const getRecommendation = (coverageNode, variant, newCoverageCode) => {
  return variant === 'recommendation' ?
    coverageNode[newCoverageCode].recommendDesc :
    coverageNode[newCoverageCode].shortDesc;
};

export const coverageHasLong = (coverageList,
  coverageVariation,
  coverageMerge,
  newCoverageCode) => {
  return !!(getCoverageProperty(coverageList, newCoverageCode, 'longDesc') ||
    getCoverageProperty(coverageVariation, newCoverageCode, 'longDesc') ||
    getCoverageProperty(coverageMerge, newCoverageCode, 'longDesc'));
};

export const getProperty = (coverageList, coverageMerge, newCoverageCode, prop) => {
  let coverage;
  if (getCoverageProperty(coverageList, newCoverageCode, prop)) {
    coverage = coverageList[newCoverageCode][prop];
  } else if (getCoverageProperty(coverageMerge, newCoverageCode, prop)) {
    coverage = coverageMerge[newCoverageCode][prop];
  }
  return coverage;
};

export const getCoverageDescription = (coverageVariation,
  coverageList,
  coverageMerge,
  variant,
  newCoverageCode,
  userData,
  product) => {
  let desc = getProperty(coverageList, coverageMerge, newCoverageCode, 'shortDesc');

  if (coverageVariation && coverageVariation[newCoverageCode]) {
    if (coverageList[newCoverageCode]) {
      desc = getRecommendation(coverageList, variant, newCoverageCode);
    } else {
      desc = getRecommendation(coverageMerge, variant, newCoverageCode);
    }
    // Do coverage variation based on conditions.
    coverageVariation[newCoverageCode]
      .filter(
        coverage => checkConditions(coverage.conditions,
          { ...userData, PRODUCT: product })
      )
      .forEach(
        coverage => {
          desc = (variant === 'recommendation' ? coverage.recommendDesc : coverage.shortDesc);
        }
      );
  }

  if (coverageHasLong(coverageList, coverageVariation, coverageMerge, newCoverageCode) &&
     (variant === 'modal' || variant === 'longOrShort')) {
    if (getCoverageProperty(coverageVariation, newCoverageCode, 'longDesc')) {
      // Do coverage variation based on conditions.
      coverageVariation[newCoverageCode]
        .filter(
          coverage => checkConditions(coverage.conditions, userData)
        )
        .forEach(coverage => { desc = coverage.longDesc || desc; });
    } else {
      desc = getProperty(coverageList, coverageMerge, newCoverageCode, 'longDesc');
    }
  }
  return desc;
};